import { getPageConfig } from '@/lib/aggregation';
import { getIsSiteWideJackpotEnabled } from '@/logic/page-config/static-page/static-page-utils';

export type FeatureFlagsResult = {
    featureFlags: Record<string, true>;
    isSiteWideJackpotEnabled: boolean;
};

export const getFeatureFlags = async ({ currentRoute }: { currentRoute: string }): Promise<FeatureFlagsResult> => {
    const response = await getPageConfig(currentRoute);

    const featureFlags =
        response?.pageConfig?.product?.data?.features?.reduce(
            (acc, featureFlag) => {
                acc[featureFlag.feature_name] = true;
                return acc;
            },
            {} as Record<string, true>
        ) || {};

    return {
        featureFlags,
        isSiteWideJackpotEnabled: getIsSiteWideJackpotEnabled(response?.pageConfig?.product)
    };
};
